import { render, staticRenderFns } from "./VChartFilters.vue?vue&type=template&id=fa7bad30&"
import script from "./VChartFilters.vue?vue&type=script&lang=js&"
export * from "./VChartFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports